import React, { useCallback, useEffect, useState } from 'react';

import { ValueBox, ValueGroup, ValueStepper } from '@candu-ai/craft/ui';

interface Props {
  columns: number;
  setProps: (props: Record<string, any>) => void;
  inputNamePrefix?: string;
  maxValue?: number;
}

export const ColumnStepper = ({
  columns,
  setProps,
  inputNamePrefix = 'form-input',
  maxValue = 10,
}: Props) => {
  const [inputProps, setInputProps] = useState<{ columns: number }>({ columns });

  useEffect(() => {
    setInputProps({ columns });
  }, [columns]);

  const onColumnsChange = useCallback(
    (value: number) => {
      setProps({ columns: value });
      setInputProps({ columns: value });
    },
    [setProps, setInputProps],
  );

  return (
    <ValueGroup>
      <ValueBox label="Columns">
        <ValueStepper
          value={inputProps.columns}
          name={`${inputNamePrefix}-columns`}
          scale="small"
          editable
          minValue={1}
          maxValue={maxValue}
          step={1}
          onChange={onColumnsChange}
        />
      </ValueBox>
    </ValueGroup>
  );
};
